import * as _ from 'lodash';
import { ModalConfirmacaoEnderecoColetaController } from '../confirmacao-endereco-coleta/modal-confirmacao-endereco-coleta.controller';

export class ModalEnderecoColetaController implements angular.IController {
  constructor($scope, $uibModal, $uibModalInstance, Pedido, pedidoId, endereco, enderecos) {
    $scope.pedidoId = pedidoId;
    $scope.enderecos = enderecos;
    $scope.endereco = _.head(enderecos.filter((end) => end.id === endereco.id));

    $scope.confirmar = async () => {
      try {
        await $uibModal.open({
          animation: false,
          template: require('../confirmacao-endereco-coleta/modal-confirmacao-endereco-coleta.html'),
          controller: ModalConfirmacaoEnderecoColetaController,
          windowClass: 'confirmacao-endereco-coleta',
          resolve: {
            valor: () => null
          },
        }).result;

        const data = await Pedido.atualizarEndereco($scope.pedidoId, $scope.endereco.id);
        if (data.error) {
          throw data.error;
        }

        $uibModalInstance.close({ endereco: $scope.endereco });
      } catch (err) {
        $uibModalInstance.dismiss(err);
      }
    };

    $scope.cancelar = () => {
      $uibModalInstance.dismiss('cancel');
    };
  }
}
